var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value !== null)?_c('div',{class:_vm.renderClass},[_c('div',{class:_vm.innerClass},[_vm._v("\n    "+_vm._s(_vm.value)+"\n    "),(Number.isInteger(Number(_vm.value)))?_c('i',{staticClass:"fa fa-star"}):_vm._e()])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }